import * as actionTypes from '../types/popupAct';

export function popupActShow(payload) {
  return {
    type: actionTypes.POPUP_ACT_SHOW,
    payload
  };
}

export function popupActClose(payload) {
  return {
    type: actionTypes.POPUP_ACT_CLOSE,
    payload
  };
}

export function dopPopupShow(payload) {
  return {
    type: actionTypes.DOP_POPUP_SHOW,
    payload
  };
}

export function dopPopupClose(payload) {
  return {
    type: actionTypes.DOP_POPUP_CLOSE,
    payload
  };
}

export function getPopupActReport(payload) {
  return {
    type: actionTypes.POPUP_ACT_REPORT,
    payload
  };
}

export function getPopupActReportSuccess(payload) {
  return {
    type: actionTypes.POPUP_ACT_REPORT_SUCCESS,
    payload
  };
}

export function getPopupActReportFail(payload) {
  return {
    type: actionTypes.POPUP_ACT_REPORT_FAIL,
    payload
  };
}

export function getPopupActErrorClose(payload) {
  return {
    type: actionTypes.POPUP_ACT_ERROR_CLOSE,
    payload
  };
}

// Добавление особых отметок
export function popupActAddNote(payload) {
  return {
    type: actionTypes.POPUP_ACT_ADD_NOTE,
    payload
  };
}
export function popupActAddNoteSuccess(payload) {
  return {
    type: actionTypes.POPUP_ACT_ADD_NOTE_SUCCESS,
    payload
  };
}
export function popupActAddNoteFail(payload) {
  return {
    type: actionTypes.POPUP_ACT_ADD_NOTE_FAIL,
    payload
  };
}

// Получение особых отметок
export function popupActGetNote(payload) {
  return {
    type: actionTypes.POPUP_ACT_GET_NOTE,
    payload
  };
}
export function popupActGetNoteSuccess(payload) {
  return {
    type: actionTypes.POPUP_ACT_GET_NOTE_SUCCESS,
    payload
  };
}
export function popupActGetNoteFail(payload) {
  return {
    type: actionTypes.POPUP_ACT_GET_NOTE_FAIL,
    payload
  };
}

export function popupHolderReportShow(payload) {
  return {
    type: actionTypes.POPUP_HOLDER_REPORT_SHOW,
    payload
  };
}

export function popupHolderReportClose(payload) {
  return {
    type: actionTypes.POPUP_HOLDER_REPORT_CLOSE,
    payload
  };
}

export function popupSetNewFormed(payload) {
  return {
    type: actionTypes.SET_NEW_FORMED,
    payload
  };
}
